<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>Change Account Quota</template>
    <template v-slot:body>
      <v-row>
        <v-col cols="12">
          <p>Change account <strong>{{ account.user }}</strong> quota.</p>
        </v-col>
        <v-col cols="10">
          <v-slider v-model="quota"
                    color="primary"
                    min="0"
                    max="10240"
                    label="Quota"
                    step="8"
                    hint="Set to 0 to grant the account unlimited disk space."></v-slider>
        </v-col>
        <v-col cols="2" class="px-0">
          <span>{{ quota }} MB</span>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn primary :loading="loading" @click="changeQuota">Change Quota</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'ChangeQuotaModal',
  mixins: [modalMixin],
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      quota: '0',
      loading: false,
    }
  },
  computed: {
    canUpdate () {
      return this.quota * 1 !== this.account._diskquota * 1
    }
  },
  methods: {
    ...mapActions({
      setFtpAccountQuota: 'ftp/setFtpAccountQuota',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    async changeQuota () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      try {
        await this.setFtpAccountQuota({
          ...this.account,
          quota: this.quota,
          _username: this.$route.query.user,
        })
        this.reportSuccess(`Account quota updated.`)
        this.$emit('quota-updated')
        this.close()
      } catch (e) {
        this.reportError(e)
        this.$emit('failed')
      }
      this.loading = false
    }
  },
  created () {
    this.quota = this.account._diskquota * 1
  }
}
</script>
